import { render, staticRenderFns } from "./InspectionEditor.vue?vue&type=template&id=70c13810&scoped=true"
import script from "./InspectionEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionEditor.vue?vue&type=style&index=0&id=70c13810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c13810",
  null
  
)

export default component.exports